
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/personal/business-insurance",
      function () {
        return require("private-next-pages/personal/business-insurance/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/personal/business-insurance"])
      });
    }
  